import { Badge } from './Badge'

type BadgeVariant = 'ok' | 'warn' | 'err' | 'info' | 'default'

const STATUS_VARIANTS: Record<string, BadgeVariant> = {
  active: 'ok',
  completed: 'info',
  on_hold: 'warn',
  cancelled: 'err',
  todo: 'default',
  in_progress: 'info',
  blocked: 'err',
  done: 'ok',
  low: 'default',
  normal: 'info',
  high: 'warn',
  urgent: 'err',
  draft: 'default',
  sent: 'info',
  submitted: 'info',
  approved: 'ok',
  accepted: 'ok',
  rejected: 'err',
  declined: 'err',
  changes_required: 'warn',
  expired: 'default',
  paid: 'ok',
  partial: 'warn',
  overdue: 'err',
  past_due: 'err',
  void: 'default',
  pending: 'default',
  requested: 'info',
  received: 'ok',
  lead: 'default',
  qualified: 'info',
  proposal: 'info',
  negotiation: 'warn',
  won: 'ok',
  lost: 'err',
  // Site & device statuses
  design: 'info',
  inactive: 'default',
  planned: 'default',
  installed: 'info',
  online: 'ok',
  offline: 'err',
  decommissioned: 'default',
  available: 'ok',
  connected: 'info',
  reserved: 'warn',
  disabled: 'err',
  // Work order statuses
  new: 'ok',
  scheduled: 'info',
  dispatched: 'warn',
}

// Statuses that show a pulsing dot
const DOT_STATUSES = new Set([
  'active', 'online', 'connected', 'available',
  'offline', 'blocked', 'overdue',
])

interface Props {
  status: string
  className?: string
}

export function StatusBadge({ status, className = '' }: Props) {
  const variant = STATUS_VARIANTS[status] ?? 'default'
  const label = status.replace(/_/g, ' ')
  const showDot = DOT_STATUSES.has(status)

  return (
    <span className={className} style={{ textTransform: 'capitalize' }}>
      <Badge v={variant} dot={showDot}>{label}</Badge>
    </span>
  )
}
